module.exports = "\n<div [formGroup]=\"group\">\n  <label *ngIf=\"!labelIsHidden\" [for]=\"id\">{{ label }}</label>\n\n  <input\n    [id]=\"id\"\n    [autocomplete]=\"autoCompleteStatus\" \n    [type]=\"type\"\n    [placeholder]=\"placeholder\"\n    [formControl]=\"control\"\n    [attr.aria-label]=\"labelIsHidden ? label : null\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/app-input/app-input.component.html
// module id = 1210
// module chunks = 0